import {
  SET_APPLICATION_LINKS,
  ADD_APPLICATION_LINKS,
  UPDATE_APPLICATION_LINK,
  REMOVE_APPLICATION_LINK,
} from 'common/types';
import _ from 'lodash';
import {getUpdatedReduxState} from 'common/utils';
import produce from 'immer';
const initialState = {
  data: [],
  total: 0,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
export const APPLICATION_LINK_ACTION_HANDLERS = {
  [SET_APPLICATION_LINKS]: (state, action) => {
    return produce(state, (draft) => {
      const data = {
        data: action.data.links,
        total: action.data.total,
      };
      getUpdatedReduxState(draft, 'applicationLinksData', data);
    });
  },
  [ADD_APPLICATION_LINKS]: (state, action) => {
    return produce(state, (draft) => {
      const data = [...state.applicationLinksData.data, ...action.data];
      const total = action.data.length + state.applicationLinksData.total;
      getUpdatedReduxState(draft, 'applicationLinksData', {data: data, total: total});
    });
  },
  [UPDATE_APPLICATION_LINK]: (state, action) => {
    return produce(state, (draft) => {
      let index = _.findIndex(
        state.applicationLinksData.data,
        (o) => o.entityId === action.data.entityId
      );
      const updatedData = produce(state.applicationLinksData.data, (draft) => {
        let rowToUpdate = _.get(draft, index);
        _.set(rowToUpdate, action.data.path, action.data.value);
      });
      getUpdatedReduxState(draft, 'applicationLinksData', {
        data: updatedData,
        total: state.applicationLinksData.total,
      });
    });
  },
  [REMOVE_APPLICATION_LINK]: (state, action) => {
    return produce(state, (draft) => {
      let copy = _.filter(
        state.applicationLinksData.data,
        (o) => o.entityId !== action.entityId
      );
      getUpdatedReduxState(draft, 'applicationLinksData', {
        data: copy,
        total: state.applicationLinksData.total - 1,
      });
    });
  },
};
